import Cookies from "js-cookie";

import { fetchCart } from "static.theme.js"

const setMiniCartCookie = () => {
  var expires = new Date(new Date().getTime() + 60 * 60 * 1000);
  Cookies.set("minicart-shown", true, {expires: expires})
}

export const runCartPopupRules = async (options) => {

  const outOfCheckoutFlow = window.location.href.indexOf("/cart") < 0 && window.location.href.indexOf("/checkout") < 0;
  const shown = Cookies.get("minicart-shown");
  const item_count = (await fetchCart)["item_count"];

  document.addEventListener("variant:add", setMiniCartCookie);

  if(outOfCheckoutFlow && !shown && item_count){

    if(options?.popover){
      const userReturnPopover = document.querySelector("#user-return-popover");
      userReturnPopover.show();
    }else{
      const cartDrawer = document.querySelector('.cart-drawer');
      cartDrawer.show();
    }
    setMiniCartCookie();
  }

}
